import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import { chartThemeColorsNeon } from "./index";
import { FiBarChart2, FiTrendingUp } from "react-icons/fi";

const parseData = (data, heading) => {
  const result = { series: [], categories: [], total: data?.total || [], bar: null };

  if (data?.values && data?.date) {
    result.series = Object.keys(data.values).map(key => ({
      name: key,
      data: data.values[key]
    }));
    result.categories = data.date;
    return result;
  }

  let barData = [];
  if (data?.bar) {
    barData = Object.values(data.bar);
  } else if (Array.isArray(data)) {
    barData = data;
  }
  
  if (barData.length > 0) {
    result.series = [
      {
        name: heading || "Data",
        data: barData.map((d) => parseFloat(d.value || 0))
      }
    ];
    result.categories = barData.map((d) => d.name);
    result.bar = barData;
  }
  
  return result;
};

const ColumnsWidget = ({ data, heading, handleReq = null, size="12", url=null, loading=false  }) => {
  const [formattedData, setFormattedData] = useState({
    series: [],
    categories: [],
    total: [],
    bar: null,
  });
  const [chartType, setChartType] = useState('bar');

  useEffect(() => {
    if(data){
      setFormattedData(parseData(data, heading));
    }else{
      setFormattedData({
        series: [],
        categories: [],
        total: [],
        bar: null,
      });
    }
  }, [data, heading]);

  return (
    <div className={`col row mx-0 ${size} mt-3 px-2 position-relative`}>
      <div className= "row mx-0 justify-content-between col px-0 ">
        <div className="dashboard__card col col-12 w-100 flex-basis-100">
          {heading ? (
            <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
              <h4 className="my-0 text-capitalize" style={{ fontWeight: 600, color: '#333' }}>{heading}</h4>
              {formattedData.series && formattedData.series.length > 0 && (
                <div className="d-flex align-items-center" style={{ gap: '2px', background: '#e9ecef', padding: '2px', borderRadius: '16px' }}>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'bar' ? '#fff' : 'transparent', boxShadow: chartType === 'bar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('bar')}
                    title="Vertical Bar Chart"
                  >
                    <FiBarChart2 size={14} color={chartType === 'bar' ? '#0d6efd' : '#495057'} />
                  </div>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'hbar' ? '#fff' : 'transparent', boxShadow: chartType === 'hbar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('hbar')}
                    title="Horizontal Bar Chart"
                  >
                    <FiBarChart2 size={14} style={{ transform: 'rotate(90deg)' }} color={chartType === 'hbar' ? '#0d6efd' : '#495057'} />
                  </div>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'line' ? '#fff' : 'transparent', boxShadow: chartType === 'line' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('line')}
                    title="Line Chart"
                  >
                    <FiTrendingUp size={14} color={chartType === 'line' ? '#0d6efd' : '#495057'} />
                  </div>
                </div>
              )}
            </div>
          ) : ""}
          {
            formattedData.series && formattedData.series.length > 0 ? (
              <>
                <div className="d-flex flex-col mx-3 my-2" style={{ gap: "3rem" }}>
                  {formattedData.total?.length > 0 && formattedData.total.map((total, idx) => (
                    <div key={idx}>
                      <p className="mb-0 font-weight-bold">
                        {total.formated_value ? total.formated_value : total.value}
                      </p>
                      <p className="mb-0" style={{ fontSize: "0.75rem" }}>
                        {total.name}
                      </p>
                    </div>
                  ))}
                </div>
                <Chart
                  width="100%"
                  height="230px"
                  type={chartType === 'hbar' ? 'bar' : chartType}
                  series={formattedData.series}
                  options={{
                    chart: {
                      type: chartType === 'hbar' ? 'bar' : chartType,
                      toolbar: { 
                        show: true,
                        tools: {
                          download: true,
                          selection: false,
                          zoom: false,
                          zoomin: false,
                          zoomout: false,
                          pan: false,
                          reset: false
                        }
                      },
                      animations: { enabled: true, easing: 'easeinout', speed: 800 }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: chartType === 'hbar',
                        borderRadius: 5,
                        distributed: formattedData.series.length === 1,
                      },
                    },
                    stroke: {
                      curve: 'smooth',
                      width: chartType === 'line' ? 3 : 0
                    },
                    markers: {
                      size: chartType === 'line' ? 4 : 0,
                    },
                    fill: {
                      type: 'solid',
                    },
                    colors: chartThemeColorsNeon,
                    dataLabels: {
                      enabled: false,
                    },
                    legend: {
                      fontSize: '10px',
                      offsetY: -6,
                      labels: {
                        colors: '#3d4246ff',
                      },
                      markers: {
                        width: 6,
                        height: 6,
                        radius: 2,
                      },
                      itemMargin: {
                        horizontal: 1,
                        vertical: 0,
                      },
                    },
                    tooltip: {
                      enabled: true,
                      custom: formattedData.bar ? ({ series, seriesIndex, dataPointIndex, w }) =>
                        `<div class='bar-widget__tooltip'>
                    <p class='bar-widget__tooltip-primary'>${
                      formattedData.bar[dataPointIndex]?.value_formatted
                        ? formattedData.bar[dataPointIndex].value_formatted
                        : formattedData.bar[dataPointIndex]?.value
                    }</p>
                      ${
                        formattedData.bar[dataPointIndex]?.value2_formatted
                          ? "<p class='bar-widget__tooltip-secondary'>" +
                            formattedData.bar[dataPointIndex].value2_formatted +
                            "</p>"
                          : ""
                      }
                    </div>` : undefined,
                    },
                    xaxis: {
                      categories: formattedData.categories,
                      labels: { show: true },
                    },
                    yaxis: {
                      labels: {
                        formatter: function (value) {
                          return typeof value === 'number' ? value.toFixed(2) : value;
                        },
                        show: chartType === 'line',
                      },
                    },
                  }}
                />
              </>
            ):(
              <div className="btn_load">
                {
                  loading ? (
                    <>
                      {/*loading */}
                      <CustomSpinLoader loading={loading}/>
                    </>
                  ) : (
                    <button className="btn btn-sm btn-primary rounded-md" onClick={()=> url && handleReq(url)}>Load Data</button>
                  )
                }
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ColumnsWidget;
